import MuxPlayer from '@mux/mux-player-react';
import { VscWorkspaceTrusted } from 'react-icons/vsc';
import { Button } from '@/components/app/ui/button';
import { calLink, getStartedLink } from '@/utils/constants';
import signInWithGoogle from '@/components/auth/signInWithGoogle';
import ShowcaseCard from '@/components/ui/v1/Cards/ShowcaseCard';
import SenjaTweets from '@/components/app/SenjaTweets';
import CTASection from '@/components/ui/CTA/CTA1';
import { Menu } from '@headlessui/react';
import UseCaseLayout from '@/components/v4/UseCaseLayout';
import { documentationSupportUseCase } from '@/lib/usecases';

// const HighlighterItem = dynamic(() => import('../components/v2/Highlighter'), {
//   ssr: false,
// });
const usecase_name = 'Documentation';
const usecase_description =
  'People want better ways to search and chat with internal and external documentation. With Mendable you can supercharge your knowledge base and create an amazing user experience in record time.';
const usecase_video_id = 'JUxSWHgHUFLusrkp9W01pcurSzT6lhyTr011o5xO6TRrQ';
const usecase_examples = [
  {
    title: 'Langchain',
    description:
      'One of the most popular frameworks for developing AI applications',
    image: '/langchain.png',
    url: 'https://python.langchain.com'
  },
  {
    title: '0x',
    description:
      '0x offers the core building blocks to create the most powerful Web3 apps',
    image: '/0xlogo.png',
    url: 'https://0x.org/docs'
  }
];

export default function usecase() {

  return <>
    <UseCaseLayout useCase={documentationSupportUseCase} />
  </>
  return (
    <section className=" pt-32 lg:pt-36 w-full h-full min-h-screen">
      <div className="w-full flex flex-col items-start justify-start mt-10 lg:mt-20 max-w-7xl mx-auto px-8 sm:px-20">
        <div className="flex flex-col w-full lg:flex-row items-start justify-between">
          <div className="lg:w-1/2 flex flex-col items-start justify-start lg:pr-12">
            <h1 className="text-gray-400 mb-2 text-md"></h1>
            <h1 className="text-white text-4xl lg:text-5xl font-bold max-w-2xl">
              Build AI Chat Search For {usecase_name}
            </h1>
            <h2 className="text-white text-md text-opacity-75 mt-4 mb-4 max-w-lg">
              {usecase_description}
            </h2>
            <div className="flex items-center justify-center mb-4">
              {/* <Rating /> */}
              <VscWorkspaceTrusted />
              <h2 className="text-gray-200 ml-2">
                Over 500,000 queries served
              </h2>
            </div>

            <div
              className={`relative w-full flex justify-start mt-4 text-accent`}
            >
              <Button
                onClick={() => signInWithGoogle()}
                className="btn text-lg text-white bg-primary 0 hover:bg-opacity-75 transition duration-150 ease-in-out group mr-2"
              >
                Get Started
                <div className="ml-1 bg-white bg-opacity-25 text-[8px] leading-3 px-[2px] py-[2px]  h-fit rounded-md">
                  ALPHA
                </div>
              </Button>

              <Menu as="div" className="relative inline-block text-left">
                <Menu.Button className="btn text-lg text-white bg-gray-800 hover:bg-opacity-75 border border-primary w-full transition duration-150 ease-in-out group">
                  Talk to Us
                </Menu.Button>
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-black ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="mailto:eric@mendable.ai"
                          className={`${
                            active ? 'bg-gray-700 text-white' : 'text-white'
                          } block px-4 py-2 text-sm`}
                        >
                          Email Us
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href={calLink}
                          onClick={() => {
                            window.location.href = calLink;
                          }}
                          className={`${
                            active ? 'bg-gray-700 text-white' : 'text-white'
                          } block px-4 py-2 text-sm`}
                        >
                          Book Meeting
                        </a>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Menu>
            </div>

            <div className="text-center md:text-left mt-28 pt-1 lg:pr-8">
              <h3 className=" font-uncut-sans text-2xl mb-4">
                Why use Mendable AI Chat Search for {usecase_name}?
              </h3>
              <p className="text-md text-gray-400 mb-6">
                There are a number of reasons top companies choose Mendable as
                their preferred AI Chat Search provider.
              </p>
              <ul className="inline-flex flex-row flex-wrap items-center  justify-center sm:justify-start sm:items-start sm:flex-col text-md text-gray-400 space-x-4 sm:space-x-0 sm:space-y-3">
                <li className="flex items-center">
                  <svg
                    className="w-3 h-3 fill-current text-emerald-500 mr-3 shrink-0"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                  </svg>
                  <span>Fully managed GUI ingestion & deployment</span>
                </li>

                <li className="flex items-center">
                  <svg
                    className="w-3 h-3 fill-current text-emerald-500 mr-3 shrink-0"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                  </svg>
                  <span>Support for the most popular data sources</span>
                </li>
                <li className="flex items-center">
                  <svg
                    className="w-3 h-3 fill-current text-emerald-500 mr-3 shrink-0"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                  </svg>
                  <span>Interchangable models (GPT 3.5, GPT 4, and more)</span>
                </li>
                <li className="flex items-center">
                  <svg
                    className="w-3 h-3 fill-current text-emerald-500 mr-3 shrink-0"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                  </svg>
                  <span>Model finetuning and chat insights</span>
                </li>
                <li className="flex items-center">
                  <svg
                    className="w-3 h-3 fill-current text-emerald-500 mr-3 shrink-0"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                  </svg>
                  <span>Prebuilt chat components, messaging bots, and API</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="lg:w-1/2 flex flex-col-reverse sm:flex-col pt-6">
            <div className="relative mt-20 lg:mt-0">
              <MuxPlayer
                className="rounded-xl box-shadow"
                thumbnailTime={8}
                playbackId={usecase_video_id}
              />
            </div>

            <div className="flex flex-col w-full">
              <div className="w-full relative my-4"></div>
              <div className="flex flex-row items-center justify-center">
                <div className="flex flex-col">
                  <h3 className="text-white text-2xl mt-20 mb-4">
                    Top companies that use Mendable
                  </h3>
                  <div className="mt-4 grid grid-cols-1 gap-x-12 lg:grid-cols-2 lg:gap-x-0">
                    <div className="mb-8 lg:mb-0 lg:mr-6 h-full w-full flex">
                      <ShowcaseCard
                        title={usecase_examples[0].title}
                        url={usecase_examples[0].url}
                        description={usecase_examples[0].description}
                        image={usecase_examples[0].image}
                      />
                    </div>
                    <div className="mb-8 lg:mb-0 lg:ml-6 h-full w-full flex">
                      <ShowcaseCard
                        title={usecase_examples[1].title}
                        url={usecase_examples[1].url}
                        description={usecase_examples[1].description}
                        image={usecase_examples[1].image}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-20 lg:pt-24">
        <SenjaTweets />
      </div>
      <div className="pt-10 lg:pt-20">
        <CTASection />
      </div>
    </section>
  );
}
